
//
// The ws.svg_parcel function returns a dom element with a svg
// Many functions of this file have been ported from php to js
//
//
// Usage ws.svg_parcel(parcel_str, options)
//
// where options is an object like: {
//             width: 100,
//             height: 100,
//             color: '#bbbbbb',
//             stroke: 1,
//             color_stroke: '#000000',
//         }
//



//
// Auto exe function that sets the ws.svg_parcel function
//
(function(){


    /**
     * Parse a parcel string into an array of coordinates
     */
    function polygon_parse(parcel_str){

        //
        // Clean the parcel str to get only the list of points
        //
        parcel_str = parcel_str
            .replace('POLYGON','')
            .replace(/[()]/g,'');


        let points = parcel_str.split(',');

        points = points.map(point => {
            point = point.split(' ');
            return point.map(parseFloat);
        });

        return points;

    }


    // http://locutus.io/php/math/deg2rad/
    function deg2rad (angle) {
        return angle * 0.017453292519943295 // (angle / 180) * Math.PI;
    }
    const M_PI_4 = 0.78539816339744830962;


    /**
     * Pseudo-Mercator projection
     */
    function polygon_projection(points){

        //
        // Pseudo-Mercator projection functions
        //

        // https://wiki.openstreetmap.org/wiki/Mercator
        function lon2x (lon) { return deg2rad(lon) * 6378137.0; }
        function lat2y (lat) { return Math.log(Math.tan(M_PI_4 + deg2rad(lat) / 2.0)) * 6378137.0; }

        //
        // Transform the points from coordinates to map positions
        //
        points = points.map(point => {

            return [
                lon2x(point[0]),
                lat2y(point[1]*-1),
            ];

        });

        return points;

    }




    /**
     * Normalize
     */
    function normalize_poligon(points, width, height, margin = 0){

        if(!points || !points.length) return [];

        width -= margin*2;
        height -= margin*2;

        // Get the min max points
        let min_a = points[0][0];
        let max_a = points[0][0];
        let min_b = points[0][1];
        let max_b = points[0][1];

        points.map(point => {
            min_a = Math.min(point[0], min_a);
            max_a = Math.max(point[0], max_a);
            min_b = Math.min(point[1], min_b);
            max_b = Math.max(point[1], max_b);
        });

        // Calculate the scale
        const diff_a = max_a - min_a;
        const diff_b = max_b - min_b;

        const scale_a = width / diff_a;
        const scale_b = height / diff_b;

        const scale = Math.min(scale_a, scale_b);

        const size_a = diff_a * scale;
        const size_b = diff_b * scale;

        const offset_a = (width-size_a) / 2;
        const offset_b = (height-size_b) / 2;


        //
        // Do normalize
        //
        return points.map(point => {
            return [
                (point[0]-min_a) * scale + offset_a + margin,
                (point[1]-min_b) * scale + offset_b + margin
            ]
        });

    }



    //
    // SVG Namespace
    //
    const svgNS = "http://www.w3.org/2000/svg";

    /**
     *
     * @param parcel_str
     * @param options
     * @returns SVGAElement element
     */
    window.ws.svg_parcel = function(parcel_str, options = {}){


        //
        // Merge options with defaults
        //
        const defaults = {
            width: 100,
            height: 100,
            color: '#bbbbbb',
            stroke: 1,
            color_stroke: '#000000',
        };
        options = {...defaults, ...options};



        //
        // Create the svg
        //
        const svg = document.createElementNS(svgNS, "svg");
        svg.setAttribute("width", options.width);
        svg.setAttribute("height",options.height);


        //
        // Empty polygon -> draw circle
        //
        if(!parcel_str){

            const circle = document.createElementNS(svgNS, "circle");
            circle.setAttribute("cx",options.width/2);
            circle.setAttribute("cy",options.height/2);
            circle.setAttribute("r",Math.min(options.width/2,options.height/2)*0.9);
            circle.setAttribute("stroke",options.stroke_color);
            circle.setAttribute("stroke-width",options.stroke);
            circle.setAttribute("fill",options.color);
            svg.appendChild(circle);

        } else {


            let points = polygon_parse(parcel_str);
            points = polygon_projection(points);
            points = normalize_poligon(points,options.width, options.height);

            const path = document.createElementNS(svgNS, "path");
            if(options.stroke){
                path.setAttribute("stroke",options.stroke_color);
                path.setAttribute("stroke-width",options.stroke);
                path.setAttribute("stroke-linejoin","round");
                path.setAttribute("stroke-linecap","round");
            }
            if(options.color){
                path.setAttribute("fill",options.color);
            }

            let pathd = "";
            points.map((point,i) => {
                pathd += (i===0) ? 'M' : 'L';
                pathd += " " + point[0] + " " + point[1] + " ";
            });

            path.setAttribute("d", pathd);

            svg.appendChild(path);
        }


        return svg;

    };



})();